document.addEventListener('DOMContentLoaded', function () {
  function setupAvailabilityPopup(triggerId, popupId, closeSelector, overlaySelector) {
    const trigger = document.getElementById(triggerId);
    const popup = document.getElementById(popupId);
    if (!trigger || !popup) return;

    const close = popup.querySelector(closeSelector);
    const overlay = popup.querySelector(overlaySelector);

    trigger.addEventListener('click', () => {
      popup.classList.add('active');

      if (typeof gtag === 'function') {
        gtag('event', 'store_stock_popup_click', {
          product_name: trigger.dataset.productName,
          product_sku: trigger.dataset.productSku,
          product_type: trigger.dataset.productType,
        });
      }
    });

    if (close) {
      close.addEventListener('click', () => popup.classList.remove('active'));
    }
    if (overlay) {
      overlay.addEventListener('click', () => popup.classList.remove('active'));
    }
  }

  setupAvailabilityPopup(
    'availability-popup-trigger',
    'availability-popup',
    '.availability-popup__close',
    '.availability-popup__overlay'
  );

  setupAvailabilityPopup(
    'availability-popup-trigger-combo',
    'availability-popup-combo',
    '.availability-popup__close_combo',
    '.availability-popup__overlay_combo'
  );
});